<template>
    <span
        :style="{width: size+'px', height: size+'px'}"
        class="cf-icon"
    >
        <component
            :is="icon"
            :fill="color"
        />
    </span>
</template>

<script>

export default {
    name: 'CommentsIcon',
    components: {
        CommentsChevronDownIcon: () => import('./CommentsChevronDownIcon'),
        CommentsDislikeIcon: () => import('./CommentsDislikeIcon'),
        CommentsLikeIcon: () => import('./CommentsLikeIcon'),
        CommentsMenuDownIcon: () => import('./CommentsMenuDownIcon'),
        CommentsMenuUpIcon: () => import('./CommentsMenuUpIcon'),
        CommentsReplyIcon: () => import('./CommentsReplyIcon'),
        CommentsSendIcon: () => import('./CommentsSendIcon'),
        CommentsSubArrowRightIcon: () => import('./CommentsSubArrowRightIcon'),
        CommentsUserIcon: () => import('./CommentsUserIcon'),
    },
    props: {
        value: {
            type: String,
            required: true
        },
        size: {
            type: [Number, String],
            default: 24
        },
        color: {
            type: String,
            default: '#000000'
        }
    },
    computed: {
        icon() {
            return `comments-${this.value}-icon`
        }
    }
}
</script>

<style lang="scss" scoped>
    span {
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
            width: 100%;
            height: auto;
        }
    }
</style>
